import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getAppThemeName } from '../../../services/appTheme';
const StyledProgressText = styled.span `
    color: ${props => props.appTheme === 'invoned' ? props.theme.dark : 'white'};
    background-color: ${props => props.theme.tertiary};
    margin-left: 40px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 1;
    padding: 3px 7px;

    &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-4px);
        left: -5px;
        width: 8px;
        height: 8px;
        border: 1px solid ${props => props.theme.tertiary};
        border-radius: 50%;
        background-color: white;
    }

    &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 6px;
        height: 1px;
        width: 36px;
        background-color: ${props => props.theme.tertiary};
    }
`;
const ProgressIndicatorText = ({ children }) => (_jsx(StyledProgressText, { appTheme: getAppThemeName(), children: children }));
export default ProgressIndicatorText;
